const MAP = { ё: "е", a: "а", e: "е", o: "о", p: "р", c: "с", x: "х", y: "у", k: "к", m: "м", t: "т", b: "б", h: "н", u: "и", 3: "з", 0: "о", "@": "а", 6: "б" };
const B = "(?<![а-яa-z])";
const PATTERNS = [
  "(?<!стра)х[уy][йяеиюё]", "пизд", "пезд", `${B}бля`, "бляд",
  `${B}(за|от|у|вы|до|на|по|про|раз|рас|с|об|подъ|въ|съ|при|пере)?ъ?еб[аилнуоы]`, `${B}еб(?![а-я])`,
  "[ао]лб[ао]еб", "уеб", "заеб", "ебанут", "ебатьс",
  `${B}сук[аиеуо]`, "мудак", "мудил", "мудач", "пид[оа]?р", "гандон", "гондон",
  "залуп", "шлюх", "ублюд",
  "fuck", "shit", "bitch", "cunt",
];
const RE = new RegExp(PATTERNS.join("|"));

function normalize(text) {
  let t = text.toLowerCase().split("").map((ch) => MAP[ch] || ch).join("").replace(/(?<=[а-я])[.\-_](?=[а-я])/g, "");
  let prev;
  while (prev !== t) { prev = t; t = t.replace(/(?<![а-я])([а-я]) (?=[а-я](?![а-я]))/g, "$1"); }
  return t.replace(/(.)\1+/g, "$1");
}

function variants(text) {
  const base = normalize(text);
  const out = [base, text.toLowerCase()];
  if (base.includes("*")) "уиеао".split("").forEach((v) => out.push(base.replaceAll("*", v)));
  return out;
}

export const hasProfanity = (...texts) => texts.some((t) => t && variants(t).some((v) => RE.test(v)));
export const PROFANITY_WARNING = "Нельзя использовать нецензурные слова. Пожалуйста, общайтесь вежливо.";
